import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as actions from '../../_redux/projectsActions';
import * as commonColumnFormatters from '../../../_common/column-formatters';
import {useCustomersForProjectsUIContext} from "../CustomersForProjectsUIContext";
import useInfiniteScrollControl from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from "../../../_common/components/CommonGrid/CommonGrid";

export function CustomersForProjectsTable({projectId, customers = []}) {
  const intl = useIntl();
  const [tableRows, setTableRows] = useState([]);
  const customersIDs = customers.map(item => item._id);
  const {text} = useCustomersForProjectsUIContext();
  const style = {fontSize: '12px'};

  const columns = useMemo(() => [
    {
      accessor: 'fullName',
      Header: intl.formatMessage({
        id: 'projects-popup-customers-column-fullName', defaultMessage: 'Full name'
      })
    },
    {
      accessor: 'idNumber',
      Header: intl.formatMessage({
        id: 'projects-popup-customers-column-idNumber', defaultMessage: 'ID'
      })
    },
    {
      accessor: 'email',
      Header: intl.formatMessage({
        id: 'projects-popup-customers-column-email', defaultMessage: 'Email'
      })
    },
    {
      accessor: 'addCustomer',
      Header: intl.formatMessage({
        id: 'projects-popup-customers-column-addCustomer', defaultMessage: 'Add'
      })
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows
      .filter(item => !(customersIDs.includes(item._id)))
      .map((item) => {
        return {
          fullName: commonColumnFormatters.LimitContentWidthNormalColumnFormatter(item.fullName, '', style),
          idNumber: commonColumnFormatters.LimitContentWidthNormalColumnFormatter(item.idNumber || '', '', style),
          email: commonColumnFormatters.LimitContentWidthNormalColumnFormatter(item.email, '', style),
          addCustomer: commonColumnFormatters.AddCustomerToProjectColumnFormatter({
            projectId,
            customerId: item._id,
            name: item.fullName,
            email: item.email
          }),
        };
      })
  ], [tableRows, customersIDs]);

  const infiniteScrollMethods = useMemo(() => ({
    getNewEntities: actions.getCustomers(text),
    getNextEntities: actions.getNextCustomers(text),
  }), [text])

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'customersForProjects',
    UIContext: useCustomersForProjectsUIContext(),
    getNewEntities: infiniteScrollMethods.getNewEntities,
    getNextEntities: infiniteScrollMethods.getNextEntities,
    onEntitiesChange: entities => setTableRows(entities),
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (
      <div className={'customers-for-projects-spinner-container'}>
        <span className={'spinner spinner-md spinner-primary'}/>
      </div>
    ),
    style: {
      overflow: 'inherit'
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      tableProps={useTable({columns, data})}
      customScrollContainerStyles={'customersForProjectsContainer'}
      customTableStyles={'customers-for-projects-table'}
    />
  );
}
